<template>
<div class="company-details">
    <h4 class="company-details__header">{{contactUsMessage}}</h4>
    <div class="company-details__opening-hours">
      <div v-html="openingHours"></div>
    </div>
    <div class="company-details__telephone">
      <a :href="`tel:${telephoneNumber}`">Call: {{telephoneNumber}}</a>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CompanyDetailsComponent extends Vue {
  @Prop({ default: 'Help and support' })
  public contactUsMessage!: string;

  @Prop({ default: '0800 808 5360' })
  public telephoneNumber!: string;

  @Prop({
    default: `<p>Mon-Fri: 9.00 - 20.00</p>
    <p>Saturday: 9.30 - 17.00</p>
    <p>Sunday: 10.00 -16.00</p>`
  })
  public openingHours!: string;
}
</script>
